export default "__VITE_ASSET__B0gjLxA2__"